import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.conceptStructure],
        config: {
            headerName: getLocalizedString("totemCode"),
            field: "code",
            isObligatory: true,
            pattern: /^[A-Z]+[A-Z0-9_]*$/,
            maxLength: 12,
            minLength: 1,
            isFixed: true,
        }
    },
    {
        pages: [paths.conceptStructure],
        config: {
            headerName: getLocalizedString("name"),
            field: "name",
            isObligatory: true,
            maxLength: 254,
            minLength: 1,
            isFixed: true,
        }
    },
    {
        pages: [paths.conceptStructure],
        config: {
            headerName: getLocalizedString("periodicity"),
            field: "periodicity",
            isObligatory: true,
            isSelect: true,
        }
    },
    {
        pages: [paths.conceptStructure],
        config: {
            headerName: getLocalizedString("hoursAndMinutes"),
            field: "hoursMinutes",
            isSelect: true,
        }
    },
    {
        pages: [paths.conceptStructure],
        config: {
            headerName: getLocalizedString("employeesProcessAmount"),
            field: "quantity",
            isSelect: true,
        }
    },
    {
        pages: [paths.conceptStructure],
        config: {
            headerName: getLocalizedString("employeesProcessPorcentaje"),
            field: "percentage",
            isSelect: true,
        }
    },
    {
        pages: [paths.conceptStructure],
        config: {
            headerName: getLocalizedString("employeesProcessBaseCalculo"),
            field: "calculationBase",
            isSelect: true,
        }
    },
    {
        pages: [paths.conceptStructure],
        config: {
            headerName: getLocalizedString("dataForRecalculation"),
            field: "reliquidation",
            isSelect: true,
        }
    },
    {
        pages: [paths.conceptStructure],
        config: {
            headerName: getLocalizedString("fees"),
            field: "honoraries",
            isSelect: true,
        }
    },
    {
        pages: [paths.conceptStructure],
        config: {
            headerName: getLocalizedString("paymentToThirdParty"),
            field: "thirdPartyPayment",
            isSelect: true,
        }
    },
    {
        pages: [paths.conceptStructure],
        config: {
            headerName: getLocalizedString("employeesProcessPeriodoImputacion"),
            field: "imputationPeriod",
            isSelect: true,
        }
    },
    {
        pages: [paths.conceptStructure],
        config: {
            headerName: getLocalizedString("employeesProcessCentroBeneficio"),
            field: "benefitCenter",
            isSelect: true,
        }
    },
    {
        pages: [paths.conceptStructure],
        config: {
            headerName: getLocalizedString("costCenter2"),
            field: "benefitCenter2",
            isSelect: true,
        }
    },
    {
        pages: [paths.conceptStructure],
        config: {
            headerName: getLocalizedString("costCenter3"),
            field: "benefitCenter3",
            isSelect: true,
        }
    },
    {
        pages: [paths.conceptStructure],
        config: {
            headerName: getLocalizedString("costCenter4"),
            field: "benefitCenter4",
            isSelect: true,
        }
    },
    {
        pages: [paths.conceptStructure],
        config: {
            headerName: getLocalizedString("costCenter5"),
            field: "benefitCenter5",
            isSelect: true,
        }
    },
    {
        pages: [paths.conceptStructure],
        config: {
            headerName: getLocalizedString("employeesProcessProyecto"),
            field: "project",
            isSelect: true,
        }
    },
    {
        pages: [paths.conceptStructure],
        config: {
            headerName: getLocalizedString("employeesProcessCodigoReferencia"),
            field: "codeRef",
            isSelect: true,
            isMultipleSelect: true,
        }
    },
    {
        pages: [paths.conceptStructure],
        config: {
            headerName: getLocalizedString("genericReference1"),
            field: "genericRef1",
            isSelect: true,
        }
    },
    {
        pages: [paths.conceptStructure],
        config: {
            headerName: getLocalizedString("genericReference2"),
            field: "genericRef2",
            isSelect: true,
        }
    },
    {
        pages: [paths.conceptStructure],
        config: {
            headerName: getLocalizedString("advance"),
            field: "advancePayment",
            isSelect: true,
        }
    },
    {
        pages: [paths.conceptStructure],
        config: {
            headerName: getLocalizedString("calculationIndicator"),
            field: "calculationIndicator",
            isSelect: true,
            isMultipleSelect: true,
        }
    },
    {
        pages: [paths.conceptStructure],
        config: {
            headerName: getLocalizedString("reportedValue"),
            field: "informedValue",
            isSelect: true,
        }
    },
    {
        pages: [paths.conceptStructure],
        config: {
            headerName: getLocalizedString("reportedValueType"),
            field: "informedValueType",
            isObligatory: false, //** Si “Valor informado” es O o B, este campo de “Tipo de valor informado” debe ser obligatorio y solo permitir seleccionar L o B.
            isSelect: true,
        }
    },
    {
        pages: [paths.conceptStructure],
        config: {
            headerName: getLocalizedString("concepts"),
            field: "concepts",
            isSelect: true,
            isMultipleSelect: true,
        }
    },
    {
        pages: [paths.conceptStructure],
        config: {
            headerName: getLocalizedString("entryMode"),
            field: "entryMode",
            isSelect: true,
            isObligatory: true,
            isMultipleSelect: true,
        }
    },
]